import { dispatch } from '../index'

import {
    ADMIN_SET_CLIENTS,
    ADMIN_SET_CLIENT_ENTRY,
    ADMIN_SET_BUILDINGS,
    ADMIN_SET_REGIONS,
    ADMIN_SET_GROUP_ENTRY,
    ADMIN_SET_GROUPS,
    ADMIN_UPDATE_GROUP,
    ADMIN_SET_TENANTS,
    ADMIN_SET_TENANT_ENTRY,
    ADMIN_REMOVE_TENANT,
    ADMIN_SET_PROPERTIES,
    ADMIN_SET_TENANTS_ADD
} from '../actionTypes'

export const setClients = (clients) => dispatch({ clients, type: ADMIN_SET_CLIENTS })
export const addClient = (client) => dispatch({ client, type: ADMIN_SET_CLIENT_ENTRY })
export const setProperties = (properties) => dispatch({ properties, type: ADMIN_SET_PROPERTIES })
export const setBuildings = (buildings) => dispatch({ buildings, type: ADMIN_SET_BUILDINGS })
export const setTenants = (tenants) => {
    return dispatch({ tenants, type: ADMIN_SET_TENANTS })
}
export const addTenant = (tenant) => {
    return dispatch({ tenant, type: ADMIN_SET_TENANT_ENTRY })
}
export const addTenants = (tenants) => {
    return dispatch({ tenants, type: ADMIN_SET_TENANTS_ADD })
}
export const removeTenant = (tenant) => {
    return dispatch({ tenant, type: ADMIN_REMOVE_TENANT })
}

// eslint-disable-next-line
const setRegions = (regions) => dispatch({ regions, type: ADMIN_SET_REGIONS })

export const setGroups = (groups) => dispatch({ groups, type: ADMIN_SET_GROUPS })
export const updateGroup = (group) => dispatch({ group, type: ADMIN_UPDATE_GROUP })
export const setGroupEntry = (group) => dispatch({ group, type: ADMIN_SET_GROUP_ENTRY })
